import Common from '../../../Common';

const Token = class extends Common {
	async read() {
		return this.get("/user/wallboard/token");
	}
}

export default Token
